<template>
  <div class="my_order">
    <div class="order_main">
      <div class="order_left">
        <user-tab></user-tab>
      </div>

      <div class="order_right bill">
        <div class="my_wallet">
          <div class="top-wallet">
            <div class="yu-title">我的账单</div>
          </div>
          <div class="bottom-wallet">
            <div class="price-tab">
              <div
                class="price-tab-item"
                v-for="(item, index) in priceTab"
                :class="{ selected: item.isSelected }"
                @click="priceListCheck(item)"
              >
                {{ item.name }}
              </div>
              <div class="daochu" @click="exportExcel()" v-loading="exportLoading">
                <svg class="icon iconbiaodan_vedioup" aria-hidden="true">
                  <use xlink:href="#iconbiaodan_vedioup" />
                </svg>
                导出
              </div>
            </div>
            <div id="range_date" class="range-date">
              交易时间
              <el-date-picker
                class="screen range_date"
                v-model="timeSlot"
                type="daterange"
                align="right"
                unlink-panels
                clearable
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                @change="getcashFlowList"
              ></el-date-picker>
              <el-button class="order_search" @click="orderClear()"
                >重置</el-button
              >
            </div>
            <div class="bill-price">
              <div class="income">
                收入：
                <span>+¥{{ cashFlowList.incomeAmount }}</span>
              </div>
              <div class="expenditure">
                支出：
                <span>-¥{{ cashFlowList.expendAmount }}</span>
              </div>
            </div>
          </div>

          <div class="price-form">
            <div class="price-form-title">
              <div class="transaction-time">交易时间</div>
              <div class="transaction-type">交易类型</div>
              <div class="transaction-type">交易方式</div>
              <div class="transaction-price">交易金额</div>
              <div class="transaction-content">内容</div>
              <div class="transaction-state">状态</div>
              <!-- <div class="transaction-yue">交易后余额</div> -->
            </div>
            <div class="price-form-list">
              <div
                class="price-item"
                v-for="(item, index) in cashFlowList.rows"
              >
                <div class="transaction-time">{{ item.time }}</div>
                <div class="transaction-type">{{ item.type }}</div>
                <div class="transaction-type">{{ item.payWay }}</div>
                <div
                  class="transaction-price"
                  :class="item.amount.indexOf('-') == '-1' ? 'green' : 'red'"
                >
                  <!-- {{
                    item.type == "REFUND" || item.type == "RECHARGE"
                      ? "+"
                      : "-"
                  }}¥-->
                  {{ item.amount }}
                </div>
                <div class="transaction-content">
                  {{ item.content.split("|")[0] }}
                </div>
                <div class="transaction-state">{{ item.status }}</div>
                <!-- <div class="transaction-yue">{{ item.nextAmount }}</div> -->
              </div>
              <div class="null" v-show="cashFlowList.total == 0 && loading">
                <img src="../../assets/img/pic_none.png" alt />
                <div>没有搜索到相关数据…</div>
              </div>
            </div>
            <div class="price-fenye">
              <el-pagination
                v-if="cashFlowList.total > 12"
                background
                layout="prev, pager, next"
                :total="cashFlowList.total"
                :page-size="12"
                @current-change="pageSize"
              ></el-pagination>
            </div>
          </div>
          <!-- 交易表格导出 -->
          <!-- <el-table id="outTable" :data="exportList.rows" style="width: 100%;display:none;">
            <el-table-column prop="time" label="交易时间"></el-table-column>
            <el-table-column label="交易类型">
              <template slot-scope="{ row }">
                <span>{{ row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易方式">
              <template slot-scope="{ row }">
                <span>{{ row.payWay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易金额">
              <template slot-scope="{ row }">
                <span>{{ claerSymbol(row.amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="内容">
              <template slot-scope="{ row }">
                <span>{{ row.content.split("|")[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="{ row }">
                <span>{{row.status}}</span>
              </template>
            </el-table-column>
          </el-table> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userTab from "./../../components/user/user_tab";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  components: {
    userTab,
  },
  data() {
    return {
      timeSlot: ["", ""],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      priceTab: [
        { name: "全部", isSelected: true, type: "" },
        { name: "充值", isSelected: false, type: "RECHARGE" },
        { name: "消费", isSelected: false, type: "PLACE_AN_ORDER" },
        { name: "提现", isSelected: false, type: "CASH_OUT" },
        { name: "退款", isSelected: false, type: "REFUND" },
        { name: "奖励", isSelected: false, type: "REWARD" },
        { name: "处罚", isSelected: false, type: "FINE" },
        { name: "加价", isSelected: false, type: "MARKUP" },
      ],
      loading: false,
      priceList: [
        {
          time: "2018-01-09  15:02",
          type: "消费",
          mode: "微信余额",
          price: "-¥100.00",
          content: "订单 6226056967666599",
          state: "交易成功",
          yue: "¥3653.25",
        },
      ],
      page: 1,
      balance: "",
      withdrawing: "",
      exportList: {
        rows: [],
        total: 0,
      },
      cashFlowList: {
        rows: [],
        total: 0,
      },
      cashFlowtype: "",
      exportLoading: false,
    };
  },
  mounted() {
    var _this = this;
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "我的账单") {
        i.isSelected = true;
      }
    }
    if (Cookies.get("token") != undefined) {
      this.getcashFlowList();
    }
  },
  methods: {
    // 导出excel
    exportExcel() {
      // if(!this.exportLoading)
      let _this = this;
      this.exportLoading = true;
      let startTime = _this.timeSlot[0];
      let endTime = _this.timeSlot[1];
      this.$fetch(
        `/order/api/cash_flow/customer_bill?pageIndex=-1&pageSize=-1&type=${this.cashFlowtype}&startTime=${startTime}&endTime=${endTime}`
      )
        .then((res) => {
          if (res.code == 0) {
            // console.log(res);
            _this.exportList = res.data.rows.map(i=>{
              i.amount=_this.claerSymbol(i.amount)
              return i
            })
          } else {
            this.$message(res.message);
          }
        })
        .finally(() => {
          if (this.exportList.length) {
            import("@/vendor/Export2Excel").then((excel) => {
              const tHeader = [
                "交易时间",
                "交易类型",
                "交易方式",
                "交易金额",
                "内容",
                "状态",
              ];
              const filterVal = [
                "time",
                "type",
                "payWay",
                "amount",
                "content",
                "status",
              ];
              const data = this.formatJson(filterVal, this.exportList);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "我的账单",
              });
            });
          }
          this.exportLoading = false;
        });
    },
    // 把要导出的数据生成 json
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "date") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    // 清除金额前面的正负号
    claerSymbol(item) {
      let reg = new RegExp(".￥", "g");
      return item.replace(reg, "");
    },
    // 表单
    orderClear() {
      this.timeSlot = ["", ""];
      this.page = 1;
      this.cashFlowtype = "";
      this.priceTab.map((i) => {
        i.isSelected = false;
        if (!i.type) {
          i.isSelected = true;
        }
      });
      this.getcashFlowList();
    },
    // 获取流水列表
    getcashFlowList() {
      var _this = this;
      let startTime = _this.timeSlot[0];
      let endTime = _this.timeSlot[1];
      this.$fetch(
        `/order/api/cash_flow/customer_bill?pageIndex=${this.page}&pageSize=12&type=${this.cashFlowtype}&startTime=${startTime}&endTime=${endTime}`
      ).then((res) => {
        if (res.code == 0) {
          res.data.total = Number(res.data.total);
          _this.cashFlowList = res.data;
          this.loading = true;
        } else {
          this.$message(res.message);
        }
      });
    },
    priceListCheck(item) {
      for (let i of this.priceTab) {
        i.isSelected = false;
      }
      this.cashFlowtype = item.type;
      item.isSelected = true;
      this.getcashFlowList();
    },
    // 页数
    pageSize(val) {
      this.page = val;
      this.getcashFlowList();
    },
    // 进入提现明细
    openWithdraw() {
      this.$router.push({ path: "/user/wallet/withdraw" });
    },
    // 余额充值
    openRecharge() {
      this.$router.push({ path: "/user/wallet/recharge" });
    },
    // 提现申请
    applyWithdraw() {
      this.$router.push({ path: "/user/wallet/money" });
    },
  },
};
</script>
<style lang="scss">
.bill {
  #range_date .range_date input.el-range-input::placeholder {
    font-size: 12px;
  }
  #range_date .range_date input.el-range-input {
    font-size: 12px;
  }
  .el-pager li,
  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    width: 32px !important;
    height: 32px !important;
    line-height: 32px !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    border-color: #3455d3 !important;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    margin: 0 4px !important;
  }
  .default-input {
    input {
      width: 190px;
      height: 30px;
      border-radius: 2px;
      border: 1px solid rgba(220, 223, 230, 1);
      padding: 9px 15px;
      font-size: 12px;
    }
    input:hover,
    input:focus,
    textarea:hover,
    textarea:focus {
      border-color: #3455d3 !important;
    }
    input::placeholder {
      font-size: 12px;
    }
  }
}
</style>
<style lang="scss">
.bill {
  .my_wallet {
    #range_date .range_date {
      width: 210px;
      height: 30px;
      margin-left: 8px;
      margin-top: 10px;
    }
    .top-wallet {
      height: 66px;
      background: #ffffff;
      padding: 24px 20px 25px 20px;
      border-bottom: 1px solid #e8eef5;
      .yu-title {
        height: 18px;
        font-size: 18px;
        color: rgba(94, 96, 102, 1);
        line-height: 18px;
        margin-bottom: 23px;
      }
    }
    .bottom-wallet {
      height: auto;
      background: #ffffff;
      .price-tab {
        height: 46px;
        padding: 14px 20px;
        color: #2f3133;
        font-size: 14px;
        display: flex;
        position: relative;
        .price-tab-item {
          margin-right: 36px;
          cursor: pointer;
          &:hover {
            color: #3455d3;
          }
        }
        .price-tab-item:last-child {
          margin-right: 0;
        }
        .selected {
          font-weight: bold;
          color: #3455d3;
          border-bottom: 1px solid #3455d3;
          padding-bottom: 25px;
        }
        .daochu {
          position: absolute;
          color: #b4b7bc;
          font-size: 12px;
          top: 13px;
          right: 20px;
          cursor: pointer;
          .iconbiaodan_vedioup {
            width: 14px;
            height: 13px;
            color: #b4b7bc;
            margin-right: 2px;
          }
          &:hover {
            color: #2f3133;
            .iconbiaodan_vedioup {
              color: #2f3133;
            }
          }
        }
      }
      .range-date {
        font-size: 12px;
        color: #5e6066;
        padding-left: 20px;
      }
    }
    .price-form {
      margin-top: 15px;
      background: #ffffff;
      margin-bottom: 100px;
      padding-bottom: 20px;
      .price-form-title {
        background: #f9fafa;
        display: flex;
        justify-content: space-evenly;
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #5e6066;
          font-size: 12px;
          height: 36px;
        }
      }
    }
    .transaction-time {
      width: 129px;
    }
    .transaction-type {
      width: 94px;
    }
    .transaction-price {
      width: 120px;
    }
    .green {
      color: #46ae32;
    }
    .red {
      color: #f75658;
    }
    .transaction-content {
      width: 273px;
      // padding-right: 88px;
    }
    .transaction-state {
      width: 70px;
    }
    .transaction-yue {
      width: 117px;
    }
    .price-item {
      display: flex;
      justify-content: space-evenly;
      .transaction-content {
        width: 273px;
        padding-right: 0;
      }
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        font-size: 12px;
      }
    }
    .price-item:nth-child(2n) {
      background: #f9fafa;
    }
    .price-fenye {
      margin-top: 20px;
      text-align: right;
    }
  }
  .bill-price {
    display: flex;
    color: #5e6066;
    font-size: 14px;
    padding-left: 20px;
    margin-top: 10px;
    padding-bottom: 10px;
    .income {
      span {
        color: #46ae32;
      }
    }
    .expenditure {
      margin-left: 21px;
      span {
        color: #f75658;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.order_search {
  width: 124px;
  height: 30px;
  background: #3455d3;
  border-color: #3455d3;
  border-radius: 2px;
  font-size: 14px;
  line-height: 5px;
  color: #fff;
  margin-left: 10px;
  &:hover {
    background: #2c4abb;
    border-color: #2c4abb;
  }
}
</style>
